// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  window.gtag("config", "G-RZ8J7NTWL5", {
    page_path: url,
  });
};
